import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[520px] md:min-h-[640px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20atmospheric%20game%20world%2C%20foggy%20forest%20with%20abandoned%20military%20structures%2C%20dramatic%20moody%20lighting%2C%20cinematic%20composition%2C%20dark%20green%20and%20grey%20tones%2C%20mysterious%20and%20foreboding%20atmosphere%2C%20concept%20art%20style&width=1800&height=900&seq=hero-bg&orientation=landscape"
          alt="人渣游戏暗黑世界"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/60" />
      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center py-16">
        <div className="inline-flex items-center gap-2 bg-accent-500/20 backdrop-blur-sm border border-accent-400/30 rounded-full px-4 py-1.5 mb-6">
          <span className="w-2 h-2 rounded-full bg-accent-400 animate-pulse" />
          <span className="text-xs font-label text-accent-200 tracking-wider uppercase">争议之作 · 深度解读</span>
        </div>
        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight">
          揭开<strong className="text-accent-300">人渣游戏</strong>的
          <br className="hidden sm:block" />
          真实面目
        </h1>
        <p className="text-base md:text-lg text-white/70 max-w-2xl mx-auto mb-8 leading-relaxed">
          一款备受争议又极具讨论度的游戏作品。我们深度解析人渣游戏的玩法机制、
          剧情设计、道德争议与玩家评价，帮你全面了解这款游戏究竟值不值得体验。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/category/wanfa-gonglue"
            className="bg-primary-500 hover:bg-primary-600 text-white px-6 py-3 rounded-lg font-label text-sm transition-all duration-200 cursor-pointer whitespace-nowrap"
          >
            探索玩法攻略 <i className="ri-arrow-right-line ml-1" />
          </Link>
          <Link
            to="/category/juqing-jiexi"
            className="bg-white/10 hover:bg-white/20 backdrop-blur-sm text-white border border-white/20 px-6 py-3 rounded-lg font-label text-sm transition-all duration-200 cursor-pointer whitespace-nowrap"
          >
            深入剧情解析 <i className="ri-book-open-line ml-1" />
          </Link>
        </div>
      </div>
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-s-line text-white/40 text-2xl" />
      </div>
    </section>
  );
}